<div class="modal-content" *ngIf="showModal">
  <h3 class="bold center" mat-dialog-title>クーポンご利用時のご注意</h3>

  <mat-dialog-content>
    <div class="pt10 pb5">
      端末に搭載されている<span class="bold red">「カメラ」</span
      >機能で起動し、対象のQRコードを読み取ってください。<br />
      <span class="bold red"
        >※「QRコードリーダー」は利用しないでください。</span
      >
      <div class="flex flex-alineitems-center flex-jsutify-enter pt5">
        <div class="mr20 icon-img">
          <img src="assets/images/camera-ok.png" width="50" />
        </div>
        <div class="icon-img">
          <img src="assets/images/qrcode-ng.png" width="50" />
        </div>
      </div>
    </div>
    <div class="pt10">
      iPhoneをお使いの場合、必ずSafariで開いてください。
      <div class="mt5 icon-img" style="margin: auto">
        <img src="assets/images/safari.png" width="50" />
      </div>
    </div>
    <div class="pt10 pb5">プライベートブラウザの設定はオフにしてください。</div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button
      class="submitBtn"
      type="button"
      readonly="readonly"
      (click)="onClick('ok')"
    >
      閉じる
    </button>
  </mat-dialog-actions>
</div>
